export default "__VITE_ASSET__T_oH1q3Y__"